import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import PageHeader from 'app/KinerjaPage/components/PageHeader'
import { isToggleEnabled } from 'configs/toggle-feature'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { DaftarPerilakuKerja } from 'app/KinerjaPamongPage/pages/pegawai/DaftarPerilakuKerja'

export async function getServerSideProps() {
  const isKinerjaEnabled = await isToggleEnabled('kinerja-spnf-enabled')

  if (!isKinerjaEnabled) {
    return {
      redirect: {
        destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
        permanent: false,
      },
    }
  }

  return { props: {} }
}

const PanduanPerilakuKerja = () => {
  return <DaftarPerilakuKerja />
}

PanduanPerilakuKerja.Layout = KinerjaLayout

PanduanPerilakuKerja.layoutOpts = {
  hasHeader: true,
  className: 'text-default bg-gray-10 !max-w-full !h-full min-h-screen',
  header: PageHeader,
}

export default PanduanPerilakuKerja
